export const SET_RANKLIST = 'SET_RANKLIST'
export const INIT_RESTAURANT_LIST = 'INIT_RESTAURANT_LIST'
export const INIT_TERMINAL_LIST = 'INIT_TERMINAL_LIST'
export const SET_TERMINAL_MODELS = 'SET_TERMINAL_MODELS'
export const SET_TERMINAL_IMEI = 'SET_TERMINAL_IMEI'
export const SET_DAILY_DRAIN_LIST = 'SET_DAILY_DRAIN_LIST'
export const SET_REALTIME_INFO = 'SET_REALTIME_INFO'
export const SET_WS = 'SET_WS'
export const SET_TOTAL_DRAIN = 'SET_TOTAL_DRAIN'
export const SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST'
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'
export const GLOBAL_CACHE = 'GLOBAL_CACHE'
export const SET_DRAIN_COUNT = 'SET_DRAIN_COUNT'
export const SET_RESTAURANT_OPTIONS = 'SET_RESTAURANT_OPTIONS'



// WEBPACK FOOTER //
// ./src/store/modules/mutation_types.js